import { render, staticRenderFns } from "./CruiseDetailHp.vue?vue&type=template&id=3564ae6e&scoped=true"
import script from "./CruiseDetailHp.vue?vue&type=script&lang=js"
export * from "./CruiseDetailHp.vue?vue&type=script&lang=js"
import style0 from "./CruiseDetailHp.vue?vue&type=style&index=0&id=3564ae6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3564ae6e",
  null
  
)

export default component.exports